import React from "react";
import { BsEye, BsEyeSlash, BsFilter } from "react-icons/bs";
import AppButton from "../../../../shared/components/generic/button/app-button";

const AssessmentInfoBar = ({
    assessmentDate,
    discountMonths,
    totalClients,
    totalEquipments,
    panelsVisible,
    filterVisible,
    onTogglePanels,
    onToggleFilter
}) => (
    <div className="apuracao-info-bar">
        <div className="apuracao-info-bar__items">
            {assessmentDate && (
                <>
                    <span className="apuracao-info-bar__item">
                        <span>Data da apuração:</span>
                        <strong>{assessmentDate}</strong>
                    </span>

                    <span className="apuracao-info-bar__separator" />
                </>
            )}

            {discountMonths && (
                <>
                    <div className="apuracao-info-bar__item">
                        <span>Meses de desconto:</span>

                        <strong className="apuracao-info-bar__highlight">
                            {discountMonths}
                        </strong>
                    </div>

                    <span className="apuracao-info-bar__separator" />
                </>
            )}

            {totalClients !== undefined && totalClients !== null && (
                <>
                    <span className="apuracao-info-bar__item">
                        <span>Total de clientes:</span>
                        <strong>{totalClients}</strong>
                    </span>

                    <span className="apuracao-info-bar__separator" />
                </>
            )}

            {totalEquipments !== undefined && totalEquipments !== null && (
                <span className="apuracao-info-bar__item">
                    <span>Total de equipamentos:</span>
                    <strong>{totalEquipments}</strong>
                </span>
            )}
        </div>

        <div className="apuracao-info-bar__actions">
            <AppButton
                type="button"
                className="apuracao-info-bar__action"
                startIcon={panelsVisible ? <BsEyeSlash /> : <BsEye />}
                onClick={onTogglePanels}
            >
                {panelsVisible ? "Ocultar painéis" : "Exibir painéis"}
            </AppButton>

            <AppButton
                type="button"
                className="apuracao-info-bar__action"
                startIcon={<BsFilter />}
                onClick={onToggleFilter}
            >
                {filterVisible ? "Ocultar filtros" : "Exibir filtros"}
            </AppButton>
        </div>
    </div>
);

export default AssessmentInfoBar;